import { getImageProxyUrl } from '@/shared/lib/proxy-url';

/**
 * VTON 결과 이미지 전용 URL 변환.
 *
 * VTON API의 결과 이미지는 base64로 내려와 호출부에서 `data:` URL로,
 * 로컬 캐시 복원 시에는 `blob:` objectURL로 들어온다. 이들은 자체 이미지
 * 프록시(`/api/image`)를 태우면 안 된다:
 *  - `data:` 페이로드에 우연히 `files` 같은 문자열이 들어가면 getImageProxyUrl 의
 *    extractFileKey 분기에 잘못 걸려 깨질 수 있다.
 *  - `data:`/`blob:`/외부 `https` URL은 이미 그대로 렌더 가능해 프록시가 불필요하다.
 *
 * data/blob/https URL은 raw 그대로 반환하고, 그 외(정적 fallback `/commerce/static/...`,
 * `/intro/...` 등)는 기존 getImageProxyUrl 로 위임한다.
 */
export function getVtonImageUrl(src: string): string {
  if (!src) return '';
  if (/^(https?|data|blob):/i.test(src)) return src;
  return getImageProxyUrl({ src });
}
